import React, { useState } from "react";
import styled from "styled-components";
import { Link as ScrollLink } from "react-scroll";
import { Data } from "../Data";
import {
  AnimatePresence,
  motion,
  useScroll,
  useTransform,
} from "framer-motion";

const Home = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 5], [0, -0.5], { clamp: false });
  const data = Data;
  const [loaded, setLoaded] = useState(false);

  return (
    <StyledHome id="home">
      <AnimatePresence initial={false}>
        {!loaded && (
          <motion.div
            initial={{ opacity: 1 }}
            animate={{
              opacity: 1,
              transition: { duration: 0.2, ease: "easeOut" },
            }}
            className="overlay"
            exit={{ opacity: 0 }}
          />
        )}
      </AnimatePresence>
      <VerticalImage
        src={data.backgroundImage}
        alt={data.companyName}
        style={{ y: y }}
        onLoad={() => setLoaded(true)}
      />

      <h1>{data.homeTitle}</h1>
      <p>{data.homeDescritpion}</p>
      <ScrollLink
        to="contact"
        smooth={true}
        duration={500}
      >
        <button>Réserver</button>
      </ScrollLink>
    </StyledHome>
  );
};

export default Home;

const StyledHome = styled(motion.section)`
  height: 100vh;
  padding: 0 6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h1 {
    font-size: var(--large);
  }
  p {
    width: 50vw;
    font-weight: 300;
    line-height: 1.5;
    @media (max-width: 992px) {
      width: 75vw;
    }
  }
  .overlay {
    position: fixed;
    inset: 0;
    backdrop-filter: blur(30px);
    z-index: 50;
  }
  button {
    padding: 1rem 2rem;
    border: 1px solid white;
    border-radius: 5px;
    background-color: transparent;
    margin-top: var(--large);
    cursor: pointer;
    color: white;
    font-size: var(--medium);
    a {
      font-weight: 300;
    }
    transition: background-color 0.3s ease;
    :hover {
      background-color: white;
      outline: 3px solid white;
      outline-offset: 3px;

      color: black;
    }
  }
`;

const VerticalImage = styled(motion.img)`
  width: 100vw;
  z-index: -1;
  filter: grayscale(0.6) brightness(0.5);
  position: fixed;
  top: -200px;
  left: 0;
  @media (max-width: 992px) {
    top: 200;
    object-fit: cover;
    height: 200vh;
    width: auto;
  }
`;

const HorizontalImage = styled(motion.img)`
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  z-index: -1;
  filter: grayscale(0.5) brightness(0.5);
  position: fixed;
  top: 0;
  left: 0;
  @media (max-width: 992px) {
    height: 100vh;
    width: auto;
    object-fit: cover;
    top: 0;
  }
`;
